import { render, staticRenderFns } from "./PeriodoFinanceiro.vue?vue&type=template&id=70043ad1&"
import script from "./PeriodoFinanceiro.vue?vue&type=script&lang=js&"
export * from "./PeriodoFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports